if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        const section = document.querySelector('[id^="MainProduct-"]');
        this.sectionId = section?.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!this.mainButton) return; // no buy buttons on this template

        this.mainPrice = document.getElementById(`price-${this.sectionId}`);
        this.lensPicker = section.querySelector('lens-picker');
        this.dock = this.closest('.miror-dock');
        this.thumb = this.querySelector('.sticky-atc__thumb');
        this.variantTitle = this.querySelector('.sticky-atc__variant');
        this.price = this.querySelector('.sticky-atc__price');
        this.button = this.querySelector('.sticky-atc__button');
        this.label = this.button.querySelector('span');

        this.button.addEventListener('click', this.onClick.bind(this));

        // Mirror the main form: Dawn and lens-picker.js already keep its price
        // and button in sync with the selected variant and lenses.
        const mirror = new MutationObserver(() => this.sync());
        [this.mainButton, this.mainPrice].forEach(
          (el) => el && mirror.observe(el, { attributes: true, childList: true, subtree: true, characterData: true })
        );
        this.sync();

        // Dock once the main Add to cart button has scrolled up out of view.
        const player = this.dock.querySelector('.apple-glass-wrapper');
        new IntersectionObserver(([entry]) => {
          const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.dock.classList.toggle('is-docked', visible);
          this.inert = !visible;
          // A player tapped open in one layout shouldn't carry over to the other.
          player?.classList.remove('is-expanded');
        }).observe(this.mainButton);

        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.sectionId) this.updateVariant(data.variant);
        });
      }

      /** A lens-required light with no lens chosen yet (and in stock). */
      get needsLens() {
        const picker = this.lensPicker;
        return !!picker?.required && picker.variantAvailable && picker.getSelectedVariantIds().length === 0;
      }

      sync() {
        const needsLens = this.needsLens;
        if (this.mainPrice) this.price.innerHTML = this.mainPrice.innerHTML;
        this.label.textContent = needsLens
          ? this.dataset.chooseLensText
          : this.mainButton.querySelector('span').textContent.trim();
        this.button.classList.toggle('is-ready', !this.mainButton.disabled);
        this.button.classList.toggle('is-muted', this.mainButton.disabled && !needsLens);
        this.button.classList.toggle('loading', this.mainButton.classList.contains('loading'));
      }

      onClick() {
        if (!this.mainButton.disabled) return this.mainButton.click();
        // Can't add yet: take the shopper to what needs their attention.
        (this.needsLens ? this.lensPicker : this.mainButton).scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      updateVariant(variant) {
        if (!variant) return;
        this.variantTitle.textContent = variant.title;
        if (this.thumb && variant.featured_image) {
          const src = new URL(variant.featured_image.src, location.href);
          src.searchParams.set('width', '96');
          this.thumb.src = src;
        }
      }
    }
  );
}
